module.exports = __webpack_public_path__ + "static/media/close.aa4fbc82.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/close.svg
// module id = 1295
// module chunks = 0